export default __webpack_public_path__ + "static/media/training@2x.a2f8e774.png";